import useSWR from "swr";
import { api } from "@/lib/api";
import { TrendUp, TrendDown, Minus, Trash } from "@phosphor-icons/react";
import { toast } from "sonner";

export default function AlertsPanel() {
  const { data, mutate, isLoading } = useSWR("alerts", () => api.listAlerts(50), {
    refreshInterval: 30000,
  });

  const clearAll = async () => {
    await api.clearAlerts();
    await mutate();
    toast.success("Alerts cleared");
  };

  const alerts = data || [];
  return (
    <aside data-testid="alerts-panel" className="bg-[#0a0a0a] h-full flex flex-col">
      <div className="flex items-center justify-between px-4 h-10 border-b border-zinc-800">
        <span className="overline text-zinc-400">Live Alerts</span>
        <button
          data-testid="clear-alerts-btn"
          onClick={clearAll}
          className="text-zinc-600 hover:text-[#FF3B30] transition-colors"
          title="Clear all"
        >
          <Trash size={12} weight="bold" />
        </button>
      </div>

      <div className="flex-1 overflow-y-auto max-h-[560px]">
        {isLoading && <div className="p-4 text-xs text-zinc-500">Loading…</div>}
        {!isLoading && alerts.length === 0 && (
          <div className="p-4 text-xs text-zinc-500">
            No alerts yet. Trend flips on your watchlist will show up here.
          </div>
        )}
        {alerts.map((a) => {
          const map = {
            bullish: { color: "#00FF66", Icon: TrendUp },
            bearish: { color: "#FF3B30", Icon: TrendDown },
            neutral: { color: "#8A8A8A", Icon: Minus },
          };
          const cfg = map[a.trend] || map.neutral;
          const time = new Date(a.created_at).toLocaleString(undefined, {
            month: "short",
            day: "2-digit",
            hour: "2-digit",
            minute: "2-digit",
          });
          return (
            <div
              key={a.id}
              data-testid={`alert-${a.display_symbol}-${a.trend}`}
              className="px-4 py-3 border-b border-zinc-900 hover:bg-[#141414] transition-colors"
            >
              <div className="flex items-center justify-between">
                <div className="flex items-center gap-2">
                  <cfg.Icon size={12} weight="bold" style={{ color: cfg.color }} />
                  <span className="text-xs font-bold text-white tabular">
                    {a.display_symbol}
                  </span>
                  <span
                    className="text-[9px] uppercase tracking-wider tabular"
                    style={{ color: cfg.color }}
                  >
                    {a.trend} · {a.confidence}%
                  </span>
                </div>
                <span className="text-[10px] text-zinc-600 tabular">{time}</span>
              </div>
              <div className="mt-1 text-[11px] text-zinc-500 tabular">
                ${Number(a.price).toLocaleString(undefined, { maximumFractionDigits: 4 })}{" "}
                <span className={a.change_pct >= 0 ? "text-[#00FF66]" : "text-[#FF3B30]"}>
                  {a.change_pct >= 0 ? "+" : ""}
                  {Number(a.change_pct).toFixed(2)}%
                </span>
              </div>
            </div>
          );
        })}
      </div>
    </aside>
  );
}
